import React from 'react';
import { Link } from 'react-router-dom';
import { useCanMutate } from '../../hooks/useCanMutate';

/**
 * Enlace a detalle/edición: "Ver" si el usuario es solo lectura, "Editar" si puede mutar.
 */
const ViewOrEditLink = ({
  to,
  className = '',
  editLabel = 'Editar',
  viewLabel = 'Ver',
  children,
}) => {
  const canMutate = useCanMutate();
  const label = children ?? (canMutate ? editLabel : viewLabel);
  return (
    <Link
      to={to}
      className={className}
      title={canMutate ? editLabel : viewLabel}
    >
      {label}
    </Link>
  );
};

export default ViewOrEditLink;
